import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import eq from 'editor/helpers/eq';
import Button from './button';

interface ErrorPopupSignature {
  Element: HTMLFormElement;
  Args: {
    errorData: string[] | null;
    onClose: () => void;
  };
  Blocks: {
    // default: [];
  };
}

export default class ErrorPopupDialog extends Component<ErrorPopupSignature> {
  @tracked errorData: string[] | null = null;

  constructor(owner: unknown, args: ErrorPopupSignature['Args']) {
    super(owner, args);
  }

  @action
  closeErrorDialog(ev: SubmitEvent) {
    ev.preventDefault();
  }

  stringContainsError(str: string) {
    return str.includes('Errors in song') || str.includes('Errors in drumset');
  }

  <template>
    <div class="flex flex-col gap-2 dark:text-white">
      {{#each this.args.errorData as |error|}}
        {{#if (this.stringContainsError error)}}
          <h2 class="text-lg font-bold">{{error}}</h2>
        {{else}}
          <p class="text-red-500 whitespace-pre-wrap">{{error}}</p>
        {{/if}}
      {{/each}}
      <Button
        @icon="xmark"
        class="text-white bg-green-600 hover:bg-green-700 p-2"
        {{on "click" this.args.onClose}}
      >Close</Button>
    </div>
  </template>
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    ErrorPopup: typeof ErrorPopupDialog;
  }
}
